// We need typescript support to do this elegantly.
import Cookies from 'js-cookie';

// This is what we really want, but this is typescript syntax
// export enum CookieKeys {
//   customerData = 'customerData',
//    cancellationReviewData = 'cancellationReviewData',
// }

/**
 * Mirroring CookieKeyInterface from php.
 * @type {{cancellationReviewData: string, customerData: string}}
 */
export const CookieKeys = {
  customerData: 'customerData',
  cancellationReviewData: 'cancellationReviewData',
  anonymousCancellationReviewKey: id => `review${id}`,
};

// Also omitting custom CookieError class because we need typescript to make that work neatly.

// Typescript would let us do:
// declare type readCookie: (key keyof CookieKeys) => object;

/**
 * Reads a cookie from storage and throws an error on invalid data.
 *
 * @type {function(string): (object)}
 */
export const readCookie = (key => {
  const rawData = Cookies.get(key);
  if (undefined === rawData) {
    throw new Error(`Cookie with key: ${key} was not found`);
  }

  if ('string' !== typeof rawData) {
    Cookies.remove(key);
    throw new Error(`Invalid raw data from cookie: ${JSON.stringify(rawData)}`);
  }

  try {
    return JSON.parse(rawData);
  } catch (SyntaxError) {
    // Either way make sure to remove the invalid cookie.
    Cookies.remove('customerData');
    // Stop here, we can't read an empty cookie.
    throw new Error('Invalid cookie data');
  }
});
